import { SVGProps, Ref, forwardRef } from 'react';

export const OvalSplitFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M6.405 10c.166-2.606.67-4.149 1.33-5.051C8.403 4.036 9.527 3.4 12 3.4s3.597.636 4.265 1.549c.66.902 1.164 2.445 1.33 5.051H20c-.375-6.442-2.718-9-8-9-5.281 0-7.625 2.558-8 9z"
                fill="currentColor"
            />
            <path
                d="M6.405 14H4c.375 6.442 2.719 9 8 9s7.625-2.558 8-9h-2.405c-.166 2.606-.67 4.149-1.33 5.051-.668.913-1.792 1.549-4.265 1.549s-3.597-.636-4.265-1.549c-.66-.902-1.164-2.445-1.33-5.051"
                fill="currentColor"
            />
        </g>
    </svg>
));
OvalSplitFilledSize24Glyph.displayName = 'OvalSplitFilledSize24Glyph';
